import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundSize: 'cover', // Ajuste la taille de l'image
        backgroundPosition: 'center', // Centre l'image
        backgroundColor: 'yellow',
        marginTop: 92,
        padding: '20px',
    },
    investCtaContainer: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: "900",
        textAlign: 'center',
    },

    subTitle: {
        fontSize: 24,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: "400",
        marginTop: 44,
        width: 510,
        textAlign: 'center',
        alignSelf: 'center'
    },

    row: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 48,
    },

    col: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 48,
    },

    investButton: {
        backgroundColor: '#535353',
        borderRadius: 24,
        height: 49,
        paddingHorizontal: 48,
        justifyContent: 'center',
    },

    investText: {
        fontSize: 24,
        color: '#FFC646',
        fontFamily: 'Montserrat',
        fontWeight: "600",
        textAlign: 'center',
    },

    contactButton: {
        backgroundColor: 'transparent',
        borderRadius: 24,
        height: 49,
        paddingHorizontal: 48,
        justifyContent: 'center',
        borderColor: '#535353',
        borderWidth: 1,
    },

    contactText: {
        fontSize: 24,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: "600",
        textAlign: 'center',
    }
});